import { DialogActions, DialogContent, DialogProps, DialogTitle, Dialog as MuiDialog } from '@mui/material'

interface Props extends DialogProps {
  dialogTitle?: string
  children: React.ReactNode
  dialogActions: React.ReactNode[]
}

export const Dialog = (props: Props) => {
  const isFullWidth = props.fullWidth ?? true
  const maxWidth = props.maxWidth ?? 'lg'

  return (
    <MuiDialog
      onClose={props.onClose}
      open={props.open}
      fullWidth={isFullWidth}
      maxWidth={maxWidth}
      aria-describedby="dialogContent"
      aria-labelledby="dialogTitle"
    >
      {props.dialogTitle && (
        <DialogTitle variant="h2" component="h2" color="primary" id="dialogTitle">
          {props.dialogTitle}
        </DialogTitle>
      )}
      <DialogContent id="dialogContent">{props.children}</DialogContent>
      <DialogActions>{props.dialogActions}</DialogActions>
    </MuiDialog>
  )
}
